import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';

import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { noopInterceptorProvider } from './core/authProvider';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration(), provideHotToastConfig(), provideHttpClient(withInterceptorsFromDi()), importProvidersFrom(HttpClientModule),noopInterceptorProvider]
};
